import { FavoritesListAction, FavoritesActionKeys } from './actions';

const initialState = [];

export function favorites(state: number[] = initialState, action: FavoritesListAction): number[] {
	switch (action.type) {
		case FavoritesActionKeys.LOAD_FAVORITES:
			return action.favoritesId;
		case FavoritesActionKeys.TOGGLE_FAVORITE:
			return action.favoritesId;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Favorites/reducer.ts